import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=dab0355a&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=dab0355a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab0355a",
  null
  
)

export default component.exports